import { faAirbnb, IconDefinition } from "@fortawesome/free-brands-svg-icons";

import { bookingIcon } from "./bookingIcon";

export const colors = {
  red: "#fe66c4",
  yellow: "#ffde59",
  blue: "#37b6ff",
};

export const MIN_NIGHTS = 3;

export const CHAT_PREFILL_EVENT = "villa:chat-prefill";

export type ChatPrefillDetail = { prompt: string };

export type BookingOption = {
  name: string;
  url: string;
  icon: IconDefinition;
};
export const bookingOptions = {
  airbnb: {
    name: "Airbnb",
    url: "https://www.airbnb.com/rooms/50213570",
    icon: faAirbnb,
  },
  bookingcom: {
    name: "Booking.com",
    url: "https://www.booking.com/hotel/gr/villa-braou.en-gb.html",
    icon: bookingIcon,
  },
};

export const socialMediaLinks = {
  instagram: "https://www.instagram.com/villabraou",
  facebook: "https://www.facebook.com/villabraou",
};
